<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-22 15:42:41
 * @LastEditors: mrh
 * @LastEditTime: 2021-03-10 10:51:49
--> 
<template>
  <div class="glist" ref="scrolls">
    <div
      v-for="(item, index) in listData"
      :key="index"
      @click="goDetails(item.spgId || item.sellerProductGoodsId)"
    >
      <van-image lazy-load :src="imgPrex + item.imageUrl" />
      <p class="overlys" v-show="item.stock == 0">
        <!-- <img :src="prefixURL + 'mobile/img/mp/sellout.png'" alt /> -->
        <span>已售罄</span>
      </p>
      <div class="tags">
        {{ item.sellerName }}
      </div>
      <div class="gtexts">
        <span class="names">{{ item.name }}</span>
        <slot name="countDowm" v-bind:item="item"></slot>
        <slot name="recommend" v-bind:item="item"></slot>
        <slot name="slotVal" v-bind:item="item"></slot>
        <slot name="search" v-bind:item="item"></slot>
        <p
          class="goodPrices"
          style="width: fit-content; background: #F8F8F8; border-radius: 15px"
        >
          <i class="icon-fenxiang iconfont" @click.stop="share(item)"></i>
          <span @click.stop="share(item)">分享</span>
          <!-- <van-button color="#FF514E" plain @click.stop="share(item)">分享</van-button> -->
        </p>
        <!-- <p class="goodPrices" v-show=''> -->
        <slot name="tj" v-bind:item="item"></slot>
        <!-- </p> -->
      </div>
    </div>
    <slot name="proGoods" />
    <share-popup
      :good-obj="shareObj"
      :show-popup="showPopup"
      @hidePopup="showPopups"
    />
  </div>
</template>

<script>
import sharePopup from "@/components/share/share";
import { recommendAdd } from "@/api/join";
export default {
  components: {
    sharePopup,
  },
  name: "goodsList",
  props: {
    listData: {
      // 商品数据data
      default: function () {
        return [];
      },
      type: Array,
    },
    // 循环list
    // slotVal: Object
  },
  data() {
    return {
      shareObj: {}, //分享弹窗obj
      showPopup: false, //分享弹窗展示
    };
  },
  mounted() {},
  methods: {
    share(e) {
      if (e.stock == 0) {
        return;
      }
      // console.log(this.imgPrex + this.shopDetail.headpic);
      this.$refs.scrolls.style["-webkit-overflow-scrolling"] = "auto";
      if (e.headpic) {
        e.imageUrl = e.headpic;
        e.shareType = "1";
        // delete e.headpic;
      } else {
        e.shareType = "0";
      }
      this.showPopup = true;
      this.shareObj = e;
    },
    showPopups(bol) {
      // console.log(bol)
      this.showPopup = bol;
      this.$refs.scrolls.style["-webkit-overflow-scrolling"] = "touch";
    },
    goDetails(sellerProductGoodsId) {
      this.$router.push({
        path: "/goodsMsg",
        query: {
          sellerProductGoodsId,
        },
      });
    },
    // recommendAdd(type, id) {
    //   if (this.$store.getters.states == "4") {
    //     this.$toast("您已被冻结");
    //     return;
    //   }
    //   let obj = {
    //     sellerProductGoodsId: id, //sellerProductGoodsId
    //     isRec: type == 0 ? "1" : "0" //1推荐， 0取消推荐
    //   };
    //   recommendAdd(obj).then(res => {
    //     // this.$store.commit(
    //     //   "user/SET_cateId",
    //     //   this.cateId ? this.cateId : this.listDatas[0].cateList[0].cateId
    //     // );
    //     this.$store.commit("user/SET_isRecommend", true);
    //     this.$toast(type == 0 ? "推荐成功" : "已取消推荐");
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
#app {
  background: #f4f4f4;
}
.glist {
  // height: auto;
  // position: relative;
  //   text-align: center;
  > div {
    display: flex;
    width: auto;
    height: auto;
    padding: 8px;
    background: #fff;
    border-radius: 10px;
    // margin-bottom: 10px;
    position: relative;
    // .van-image {
    //   width: 110px;
    //   height: 110px;
    //   margin-right: 5px;
    // }
    .van-count-down {
      // width: 110px;
      height: 20px;
      color: #999;
      //   transform: scale(0.83);
      font-size: 12px;
      line-height: 20px;
      margin-right: 4px;
    }
    .gtexts {
      width: 100%;
      height: auto;
      display: flex;
      flex: 1;
      flex-flow: column;
      justify-content: space-between;
      .names {
        // height: 38px;
        color: #444;
        font-size: 14px;
        // margin-top: 0px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      .factorys {
        color: #208fff;
        font-size: 12px;
        padding: 2px 0;
      }

      .stockNull {
        color: #999 !important;
      }
      .shopMoney {
        color: #DC0D0D;
        font-size: 12px;
        font-weight: bold;
      }

      .goodPrices {
        // width: fit-content;
        height: 16px;
        // background: #F8F8F8;
        // border-radius: 15px;
        padding: 3px 6px;
        margin-top: 6px;
        // margin-bottom: 4px;
        display: flex;
        align-items: center;
        i {
          font-size: 20px;
          color: #dc0d0d;
        }
        span {
          color: #dc0d0d;
          font-size: 12px;
        }
        // .prices {
        //   font-size: 17px;
        //   color: #ff1310;
        //   font-weight: bold;
        // }
        // .guides {
        //   font-size: 12px;
        //   color: #999;
        //   text-decoration: line-through;
        // }
        // .shares {
        //   font-size: 14px;
        //   color: #ff1310;
        //   margin-right: auto;
        // }
        // .shares::before {
        //   content: "分享赚";
        //   color: #1d1d1d;
        // }
        .van-button {
          width: 71px;
          height: 26px;
          line-height: 26px;
          padding: 0;
          border: 1.5px solid rgba(255, 81, 78, 1);
          border-radius: 16px;
          margin-left: auto;
          .van-button__text {
            font: 14px/26px "Microsoft YaHei";
            // font-weight: bold;
            color: #fff;
          }
        }
        // .searchShare {
        //   width: 157px !important;
        //   margin-left: auto;
        // }
      }
      .van-button:not(.copy) {
        width: 71px;
        height: 26px;
        line-height: 26px;
        padding: 0;
        border: 1.5px solid rgba(255, 81, 78, 1);
        border-radius: 16px;
        margin-left: auto;
        .van-button__text {
          font: 14px/26px "Microsoft YaHei";
          // font-weight: bold;
          color: #fff;
        }
      }
      .isRecommend {
        width: 71px !important;
        border: 1.04px solid #FF9A34 !important;
        background: #fff !important;
        color: #FF9A34 !important;
        .van-button__text {
          font: 13px/23px "Microsoft YaHei";
          // font-weight: bold;
          color: #FF9A34 !important;
        }
      }
      > div {
        display: flex;
        align-items: center;
        margin-top: 8px;
        > p {
          display: flex;
          align-items: center;
          margin-right: auto;
          span:first-child {
            font-size: 17px;
            color: #ff1310;
            padding-right: 4px;
            font-weight: bold;
          }
          span:nth-child(2) {
            font-size: 12px;
            color: #999;
            text-decoration: line-through;
          }
          span:nth-child(3) {
            font-size: 12px;
            color: #dc0d0d;
            font-weight: normal;
            margin-left: 4px;
          }
        }
        /deep/.van-button:not(.copy) {
          width: 60px;
          height: 25px;
          line-height: 25px;
          padding: 0;
          border: 1.5px solid #FF9A34;
          border-radius: 25px;
          .van-button__text {
            font-size: 14px;
            font-weight: bold;
            // color: #ff514e;
          }
        }
      }
    }
    .blacks {
      -webkit-filter: grayscale(100%) opacity(50%);
      -moz-filter: grayscale(100%) opacity(50%);
      -ms-filter: grayscale(100%) opacity(50%);
      -o-filter: grayscale(100%) opacity(50%);
      filter: grayscale(100%) opacity(50%);
      filter: gray;
      filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    }
    .overlys {
      width: 50px;
      height: 50px;
      background: #000;
      opacity: 0.5;
      text-align: center;
      line-height: 50px;
      border-radius: 50%;
      position: absolute;
      left: 21px;
      top: 21px;
      z-index: 9;
      span {
        display: block;
        font-size: 12px;
        color: #fff;
      }
    }
    // .overlys {
    //   position: absolute;
    //   top: 0px;
    //   left: 0px;
    //   bottom: 0;
    //   right: 0;
    //   margin: 0 auto;
    //   z-index: 9;
    //   img {
    //     width: 40px;
    //     height: 39.5px;
    //   }
    // }
    .tags {
      width: 75px;
      height: 16px;
      text-align: center;
      line-height: 16px;
      background: linear-gradient(to right, #a4e3ff 0%, #208fff 100%);
      font-size: 12px;
      color: #fff;
      border-radius: 0 0 5px 5px;
      position: absolute;
      left: 8px;
      top: 67px;
    }

    .success {
      color: #B0B3BE !important;
      font-size: 12px;
      margin-left: 0;
    }
    .success::before {
      content: "已拼";
      color: #8b8e97;
    }
    // .success::after {
    //   content: "份";
    //   color: #8b8e97;
    // }
    .buyNums {
      color: #B0B3BE !important;
      font-size: 12px;
    }
    .buyNums::before {
      content: "差";
      color: #8b8e97;
    }
    .buyNums::after {
      content: "份";
      color: #8b8e97;
    }
  }
}
</style>

